import { toggleAutoInit } from './components/tiny-ui-toggle.js';

(function($) {

  $(function() {

    (function (C, A, L) {
        let p = function (a, ar) {
          a.q.push(ar);
        };
        let d = C.document;
        C.Cal =
          C.Cal ||
          function () {
            let cal = C.Cal;
            let ar = arguments;
            if (!cal.loaded) {
              cal.ns = {};
              cal.q = cal.q || [];
              d.head.appendChild(d.createElement("script")).src = A;
              cal.loaded = true;
            }
            if (ar[0] === L) {
              const api = function () {
                p(api, arguments);
              };
              const namespace = ar[1];
              api.q = api.q || [];
              if (typeof namespace === "string") {
                cal.ns[namespace] = cal.ns[namespace] || api;
                p(cal.ns[namespace], ar);
                p(cal, ["initNamespace", namespace]);
              } else p(cal, ar);
              return;
            }
            p(cal, ar);
          };
      })(window, "https://app.cal.com/embed/embed.js", "init");
      Cal("init");

    /** Globals **/
    var $document = $(document),
      $window = $(window),
      $body = $('body');

    // Mobile nav
    $document.on('click', '.nav-trigger', function() {
      $('.mobile-navigation').fadeToggle(400);
      $body.toggleClass('nav-open');

      return false;
    });

    // Mobile nav
    $document.on('click', '.menu-item-has-children > a', function() {
      if ($window.width() <= 992 ) {
        var $button = $(this);
        $button.parent().toggleClass('open');
        $button.next('.sub-menu').slideToggle(400);

        return false;
      }
    });

    // Modal trigger
    $document.on('click', '.modal-trigger', function() {
      var $button = $(this);
      var target = $button.attr('href');
      $(target).fadeToggle(400);
      $body.toggleClass('modal-open');

      return false;
    });

    // Modal close
    $document.on('click', '.modal-close', function() {
      $('.filter-modal').fadeOut(400);
      $body.removeClass('modal-open');

      return false;
    });

    // Smooth scroll to location
    $document.on('click', '.scroll', function() {
      var $button = $( this ),
        url = $button.attr( 'href' ),
        target = url.split("#").pop(),
        $target = $( '#' + target );

      if ($target.length && $window.width() >= 992) {
        $( 'html, body' ).animate( {
          scrollTop: $target.offset().top - 170
        }, 750 );
        return false;
      }
    });

    toggleAutoInit();

  });

})(jQuery);
